// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"454":"446c3c9d","501":"92d035a1","593":"054540a5","773":"cf28a149","797":"fe5e62f7"}[chunkId] + ".chunk.js";
};